import React, { Component } from 'react';
import {get} from 'lodash'
import {RaisedButton, FlatButton, Avatar, FontIcon, List, ListItem, IconButton} from 'material-ui'
import util from '../utils/util'

class StreamItem extends Component {
	constructor(props) {
	    super(props);
	    this.state = {
	    	playing_response_idx: -1,
	    	recording_duration: -1,
	    	confirm_post: false,
	    	my_recordings: [],
	    	listened_responses: []
	    }
	    this.startRecording = this.startRecording.bind(this)
	    this.stopRecording = this.stopRecording.bind(this)
	    this.postRecording = this.postRecording.bind(this)
	    this.recordingIncrementSecond = this.recordingIncrementSecond.bind(this)

	}

	componentDidMount() {

	}

    componentWillUnmount() {

    }

    call(author) {
    	this.props.onCall(author)
    }

    playing() {
    	return this.state.playing_response_idx != -1
    }

    play(idx) {
    	let {data} = this.props
    	let {playing_response_idx} = this.state
    	if (idx > data.responses.length - 1 || playing_response_idx == idx) idx = -1
    	this.setState({playing_response_idx: idx}, () => {
    		if (idx > -1) {
	    		util.play_response(data.id + 1, idx+1, () => {
	    			this.stop()
	    		})    			
    		}
    	})    		
    }

    stop() {
    	let {playing_response_idx, listened_responses} = this.state
    	listened_responses.push(playing_response_idx)
    	this.setState({playing_response_idx: -1, listened_responses: listened_responses})
    }

    renderRecordSection() {
    	let {recording_duration, confirm_post} = this.state
    	let recording = recording_duration > -1
		const IST = {
			color: '#FFFFFF',
			paddingRight: '20px'
		}
		const RE_IST = {
			color: '#FF596C'
		}		
		const AV_ST = {cursor: 'pointer', float: 'left', display: 'inline-block', marginRight: "5px"}
    	if (confirm_post) {
    		let play_icon = <Avatar style={AV_ST} color={ "black" } backgroundColor="white" icon={<FontIcon className="material-icons">play_arrow</FontIcon>} />
    		return (
    			<div className="row">
	    			<div className="col-sm-1"></div>
    				<div className="col-sm-1 ColPadded">
    					<IconButton iconClassName="material-icons" onClick={this.startRecording} iconStyle={RE_IST}>restore</IconButton>
	    			</div>
    				<div className="col-sm-8">	    			
	    				<div className="Response">
							{ play_icon }
							<span className="waveform" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/media/waveform.png)`}}></span>
							<div style={{clear: 'left'}}></div>
						</div>	
	    			</div>
    				<div className="col-sm-2 ColPadded Right">	    			
	    				<IconButton iconClassName="material-icons" onClick={this.postRecording} iconStyle={IST}>file_upload</IconButton>
	    			</div>
    			</div>
			) 
		} else if (recording) {
    		return (
    			<div className="row">
    				<div className="col-sm-6">
	    				<span className="RecordingText">Recording... {recording_duration}s</span>
	    			</div>
    				<div className="col-sm-6">	    			
	    				<IconButton iconClassName="material-icons" onClick={this.stopRecording} iconStyle={{color: '#FF596C'}}>stop</IconButton>
	    			</div>
    			</div>
			)
   		
    	} else return <span className="RecordButton" onClick={this.startRecording} style={{backgroundImage: `url(${process.env.PUBLIC_URL}/media/mic.png)`}}></span>
    }

    recordingIncrementSecond() {
    	this.setState({recording_duration: this.state.recording_duration + 1})
    }

    startRecording() {
    	this.setState({recording_duration: 0, confirm_post: false}, () => {
    		this.interval_id = window.setInterval(this.recordingIncrementSecond, 1000)
    	})
    }

    stopRecording() {
    	if (this.interval_id) window.clearInterval(this.interval_id)
    	this.setState({confirm_post: true})
    }

    postRecording() {
    	let {my_recordings} = this.state
    	my_recordings.push({
			author: 'You',
			date: 'Just now'
    	})
    	this.setState({recording_duration: -1, my_recordings: my_recordings, confirm_post: false})
    }

	render() {
		let {data} = this.props
		let {playing_response_idx, my_recordings, listened_responses} = this.state
		let responses = data.responses.concat(my_recordings)
		let _response
		if (responses.length > 0) {
			_response = (
				<div>
					<div className="responses">
						{ responses.map((r, i) => {
							let now_playing = i == playing_response_idx
							let st = {}
							const AV_ST = {cursor: 'pointer', float: 'left', display: 'inline-block', marginRight: "5px"}
							if (now_playing) st.backgroundColor = "#F2C94C"
							let is_caption = i == 0
							let subhead = null
							if (is_caption) subhead = <span className="subhead">Caption</span>
							else if (i == 1) subhead = <span className="subhead">Responses</span>
							let play_icon = <Avatar style={AV_ST} onClick={this.play.bind(this, i)} color={now_playing ? "#EFEFEF" : "black" } backgroundColor="white" icon={<FontIcon className="material-icons">play_arrow</FontIcon>} />
							let call_icon = (
								<div className="callCol col-sm-2">
									<Avatar style={AV_ST} onClick={this.call.bind(this, r.author)} color="white" backgroundColor="#00C80B" icon={<FontIcon className="material-icons">call</FontIcon>} />
								</div>
							)
							if (r.author == "You") call_icon = null
							if (!is_caption) call_icon = null
							let avatar_img = `${process.env.PUBLIC_URL}/media/avatars/${r.author}.jpg`
							let listened = listened_responses.indexOf(i) > -1
							let mid_cols = 10
							let cls = "Response"
							let holder_cls = "Holder"
							if (listened) cls += " Listened"
							if (is_caption) {
								cls += " Caption"
								holder_cls += " Caption"
								mid_cols = 8
							}
							st.backgroundImage = `url(${process.env.PUBLIC_URL}/media/waveform.png)`
							let response_els = [
								(
								<div className={`col-sm-${mid_cols}`}>
									<div className={cls} style={st}>
										{ play_icon }
										<div style={{clear: 'left'}}></div>
									</div>	
								</div>	
								)					
							]
							if (call_icon) response_els.push(call_icon)
							let author_sec = (
								<div className="authorCol col-sm-2">
									<Avatar src={avatar_img} style={AV_ST} />
								</div>
							)
							let date_sec 
							if (is_caption) {
								response_els.splice(0, 0, author_sec)
								date_sec = <div className="date">{ data.date }</div>
							} else {
								response_els.push(author_sec)
							}
							return (
								<div className={holder_cls}>
									{ date_sec }
									<div className='row'>
										{ response_els }
									</div>
								</div>
							)
						})
						}
					</div>

					<div className="Record">
						{ this.renderRecordSection() }
					</div>
				</div>
			)
		} else _response = <span className="empty">No resposes yet</span>
		let author = null // (<span className="author">Update from <b>{ data.author }</b> @ {data.date}</span>)
		let COL_ST = {paddingLeft: '0px', paddingRight: '0px'}
		return (
			<div className="StreamItem">
				<div className="row">
					<div className="col-sm-7" style={COL_ST}>
						{ author }
						<span className="image" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/media/update${data.id+1}/image.jpg)`}}></span>
					</div>			
					<div className="col-sm-5" style={COL_ST}>
						{ _response }
					</div>
				</div>
			</div>
		)
	}
}

StreamItem.defaultProps = {
	data: {}
}

export default StreamItem;


// WEBPACK FOOTER //
// ./src/components/StreamItem.js